import React, {Component} from 'react'
import {Button, Col, DatePicker, Form, Input, message, Modal, Row, Select, Spin, Table,Typography } from 'antd';
import {baseUrl} from "../../api";
import ajax from "../../api/ajax";
const { Text } = Typography;
const PAGE_SIZE = 5;
class UserOrderSubSetModal extends Component{
    state={
        loading: false,
        visible: false,
        openId:null,
        pageNum:1,
        selectedRowKeys:[],
    }
    // 日期选择
    onDateChange = (value, dateString) => {
        console.log(value, dateString)
        this.setState({
            deliveryFromDt: dateString
        })
    }
    // 日期选择
    onDateChange2 = (value, dateString) => {
        console.log(value, dateString)
        this.setState({
            deliveryToDt: dateString
        })
    }

    hide=()=>{
        this.setState({
            visible:false
        },()=>{
            this.props.updateVisible(false)
        })
    }
    handleOk=()=>{
        this.doUnSub()
    }
    handleCancel=()=>{
        this.hide()
    }

    doUnSub=()=>{
        let subInfos = [];
        this.state.tableDataSource.forEach((value,key)=>{
            let subInfo = {}
            if(this.state.selectedRowKeys.includes(value.id)){
                subInfo = {
                    orderNo:value.orderNo,
                    status:"subscribe"
                }
            }else{
                subInfo = {
                    orderNo:value.orderNo,
                    status:"unsubscribe"
                }
            }
            subInfos.push(subInfo)
        })
        this.setState({
            loading:true,
        })
        let params = {
            openId:this.state.openId,
            orderNos:subInfos
        }
        let result = ajax(baseUrl+"/api/v1/p/unsubscribeOrders",params,"PUT");
        result.then((resp)=>{
            if(resp.code === 200){
                message.info("更新成功！")
                //this.hide()
            }else{
            }
        }).catch(()=>{
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }

    searchList=(page)=>{
        console.log(page,'page')
        this.props.form.validateFields((err, values) => {
            values.pageNum = !!page?page:1;
            this.setState({
                pageNum:!!page?page:1
            })
            values.pageSize= PAGE_SIZE
            values.openId= this.state.openId
            if (!err) {
                this.getOrderList(values);
            }
        });
    }
    getOrderList=(params={})=>{
        this.setState({
            loading:true,
        })
        if(!params || !params.openId){
            params = Object.assign(params,{
                openId: this.state.openId
            })
        }
        if(!params || !params.pageNum) {
            params = Object.assign(params,{
                pageNum: this.state.pageNum,
                pageSize: PAGE_SIZE
            })
        }
        if(params) {
            const {deliveryFromDt, deliveryToDt} = this.state
            params = Object.assign(params, {
                uncomplete: 'Y',
                notInStatusStr: 'new,audit,cancelled',
                deliveryFromDt: deliveryFromDt,
                deliveryToDt:deliveryToDt
            })
        }
        let result = ajax(baseUrl+"/api/v1/p/wms/orderList",params);
        result.then((resp)=>{
            if(resp.code === 200){
                this.setState({
                    total: resp.data.total,
                    tableDataSource:resp.data.rows
                },()=>{
                    let selectedRowKeys = new Array()
                    this.state.tableDataSource.forEach((value,key)=>{
                        if(value.subscribeStatus === 'subscribe'){
                            selectedRowKeys.push(value.id)
                        }
                    })
                    this.setState({
                        selectedRowKeys
                    })
                })
            }else{
                this.setState({
                    tableDataSource:[]
                })
            }
        }).catch(()=>{
            this.setState({
                tableDataSource:[]
            })
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.openId!=this.state.openId) {
            this.setState({
                openId: nextProps.openId
            },()=>{
                if(this.state.visible){
                    this.searchList()
                }
            })
        }
        if(nextProps.visible!=this.state.visible) {
            this.setState({
                visible: nextProps.visible
            },()=>{
                if(this.state.visible && nextProps.openId){
                    this.props.form.resetFields()
                    this.searchList()
                }
            })
        }
    }
    render() {
        const orderStatus = {
            audit:'待审核',
            audited:'待订舱',
            booked:'已订舱',
            boxed:'已装箱',
            declare:'待报关',
            declaring:'报关中',
            released:'已放行'
        };

        const logisticsStatus = {
            waiting:"待提货",
            transport:'运输中',
            declaring:'报关中',
            released:'已放行',
            boxed:'已装箱',
            destination:'已到达'
        }
        const columns = [
            {
                title: '订单编号',
                dataIndex: 'orderNo',
                render: (text, record) => (
                    <span>
                       {text}
                    </span>
                )
            },
            /*{
                title: '箱数CTNS',
                dataIndex: 'toNum',
            },
            {
                title: '毛重(Kg)',
                dataIndex: 'toGrossWeight',
            },
            {
                title: '总价',
                dataIndex: 'totalValue',
            },*/
            {
                title: '起运地',
                dataIndex: 'originCity',
                render: (text,record) => (
                    <span>
                        {record.originCountry}&nbsp;{text}
                  </span>
                )
            }, {
                title: '目的地',
                dataIndex: 'destinationCountry',
                render: (text,record) => (
                    <span>
                        {record.destinationCountry}&nbsp;{record.destinationCity}
                    </span>
                )
            },{
                title: '订单状态',
                dataIndex: 'orderStatus',
                render: (text,record) => (
                    <span>
                        {orderStatus[text]}
                    </span>
                )
            },{
                title: '物流状态',
                dataIndex: 'logisticsStatus',
                render: (text,record) => (
                    <span>
                        {logisticsStatus[text]}
                    </span>
                )
            },{
                title: '提货时间',
                dataIndex: 'deliveryTime',
            }
        ];
        const {selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                    selectedRowKeys
                })
            },
            getCheckboxProps: record => ({
                //defaultChecked: record.subscribeStatus === 'subscribe', // Column configuration not to be checked
                name: record.orderNo,
            }),
        };
        const form = this.props.form
        const { getFieldDecorator } = form;
        const { Option } = Select;
        return (
            <div>
                <Modal
                    title="订单告警设置"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    width={"80%"}
                    style={{padding:'20px'}}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.handleOk}>
                            保存
                        </Button>,
                    ]}
                >
                    <div className='box-shadow margin-bootom'>
                        <br/>
                        <Form labelCol={{
                            lg: {span: 7},
                            md: {span: 9},
                        }}
                              wrapperCol={{
                                  lg: {span: 14},
                                  md: {span: 12},
                              }}
                        >
                            <Row>
                                <Col span={6}>
                                    <Form.Item label="订单编号">
                                        {getFieldDecorator('orderNo', {
                                            rules: [
                                                {
                                                    required: false,
                                                },
                                            ],
                                        })(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="起运地">
                                        {getFieldDecorator('departure', {
                                            rules: [
                                                {
                                                    required: false,
                                                },
                                            ],
                                        })(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="目的地">
                                        {getFieldDecorator('destination', {
                                            rules: [
                                                {
                                                    required: false,
                                                },
                                            ],
                                            //initialValue:"马拉舍维奇",
                                        })(<Input/>)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="品名(中文)">
                                        {getFieldDecorator('goodName', {
                                            rules: [
                                                {
                                                    required: false,
                                                },
                                            ],
                                        })(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="订单状态">
                                        {getFieldDecorator('orderStatus', {
                                            initialValue:'',
                                            rules: [
                                                {
                                                    required: false,
                                                },
                                            ],
                                        })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                            <Option value="">全部</Option>
                                            {/*<Option value="audit">待审核</Option>*/}
                                            {/*<Option value="audited">待订舱</Option>*/}
                                            <Option value="booked">已订舱</Option>
                                            <Option value="boxed">已装箱</Option>
                                            <Option value="declare">待报关</Option>
                                            <Option value="declaring">报关中</Option>
                                            <Option value="released">已放行</Option>
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="物流状态">
                                        {getFieldDecorator('logisticsStatus', {
                                            initialValue:'',
                                            rules: [
                                                {
                                                    required: false,
                                                },
                                            ],
                                        })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                            <Option value="">全部</Option>
                                            <Option value="waiting">待提货</Option>
                                            <Option value="boxed">已装箱</Option>
                                            <Option value="transport">运输中</Option>
                                            <Option value="declaring">报关中</Option>
                                            <Option value="released">已放行</Option>
                                            {/*<Option value="destination">已到达</Option>*/}
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="提货时间">
                                        {getFieldDecorator('deliveryFromDt')(<DatePicker style={{width:"100%",minWidth:10}}
                                                                                         showTime
                                                                                         format="YYYY-MM-DD HH:mm:ss"
                                                                                         onChange={this.onDateChange}
                                        />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="至">
                                        {getFieldDecorator('deliveryToDt')(<DatePicker style={{width:"100%",minWidth:10}}
                                                                                       showTime
                                                                                       format="YYYY-MM-DD HH:mm:ss"
                                                                                       onChange={this.onDateChange2}
                                        />)}
                                    </Form.Item>
                                </Col>
                                <Col span={12} style={{paddingTop: '12px', paddingLeft:'10px'}}>
                                    已勾选的订单发生预警时将主动推送消息给用户
                                </Col>
                                <Col span={6} style={{float: 'right', marginBottom: '20px'}}>
                                    <Button type='primary' htmlType='submit'
                                            style={{float: 'right', marginRight: '13%'}} onClick={(e)=>{
                                        e.preventDefault();
                                        this.searchList()
                                    }}>查询</Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    <div className='box-shadow'>
                        <Spin size="large" spinning={this.state.loading}>
                            <Table
                                rowKey='id'
                                size="middle"
                                bordered
                                columns={columns}
                                rowSelection={rowSelection}
                                dataSource={this.state.tableDataSource}
                                pagination={{
                                    current: this.state.pageNum,
                                    total:this.state.total,
                                    pageSize:PAGE_SIZE,
                                    showQuickJumper: true,
                                    onChange:(page, pageSize)=>{
                                        this.setState({
                                            pageNum:page
                                        },()=>{
                                            this.searchList(page)
                                        })
                                    }
                                }}
                            />
                        </Spin>
                    </div>
                </Modal>
            </div>
        )
    }
}
const UserOrderSubSetModalForm = Form.create()(UserOrderSubSetModal)
export default UserOrderSubSetModalForm